import { render, staticRenderFns } from "./certificateDataDoctorPra.vue?vue&type=template&id=dfaeff9c&"
import script from "./certificateDataDoctorPra.vue?vue&type=script&lang=js&"
export * from "./certificateDataDoctorPra.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../yiweb/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports